import React from "react";

import Transition from "../../Transition";
import Layout from "../Layout";
import styled from "styled-components";
import { H1 } from "../../mdx/Elements";
import { Heading } from "../Components";

const start = { opacity: 0, y: 30 };
const end = { opacity: 1, y: 0 };

const SectionHeader = styled(Heading)`
  --from: var(--opaqueVatsimWhite);
  --to: var(--vatsimBlue);
  margin-bottom: var(--l);
`;

const NavigraphHolder = styled.div`
    background: #040d21;
    width: 100%;
`

const NavigraphContainer = styled.section`
    --landingBg: #040d21;
    --landingTextBlue: #0b2549;
    --landingTextLight: #ffffff;
    --landingTextDark: #000000;
    --landingTextLightSecondary: #e1e1e1;
    --landingPrimary: #ffffff;
    --landingTertiary: #ebedf0;
    --landingAccent: #3d4fe0;
    --landingAccentOpaque: rgba(140, 150, 221, 0.2);
    --landingBorder: rgba(0, 0, 0, 0.1);
    width: 50%;
    padding: 0px;
    margin-top: 20px;
    margin-bottom: -40px;
    margin-left: auto;
    margin-right: auto;

    a { 
        margin-top: 0px;
    }
    
    img { 
        margin-top: 0px;
    }
`;

const NavigraphSponsor = () => {
  return (
    <NavigraphHolder>
        <Layout guidesColor="rgba(0, 0, 0, 0)">
            <SectionHeader>
                Navigation data powered by
                <NavigraphContainer>
                    <a href="https://navigraph.com" target="_blank">
                        <img src="https://navigraph.com/assets/images/logos/navigraph-logo-text.svg" height="75px" />
                    </a>
                </NavigraphContainer>
            </SectionHeader>
        </Layout>
    </NavigraphHolder>
  );
};

export default NavigraphSponsor;
